<template>
  <v-container v-if="transferItems">
    <div class="text-center background text border pt-2">
      <div></div>
      <div class="d-flex justify-content-around">
        <img :src="images.logo" style="width: 80px" alt="" />
        <div>
          <h1 class="mt-5">Sell offers</h1>
          Transfering from {{ worldsData.from }} to {{ worldsData.to }}
        </div>
        <img :src="images.femaleLogo" style="width: 80px" alt="" />
      </div>

      <v-container class="text-center">
        <v-data-table
          class="default-text"
          :headers="headers"
          :items="transferItems"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          hide-default-footer
          :items-per-page="1000"
        >
          <template v-slot:[`item`]="{ item }">
            <tr v-if="item.profitViable == true" class="myrow text-left mb-4">
              <td class="col-2 text-left">
                <img :src="item.imgUrl" style="width: 32px; height: 32px" />
                
                 <!-- {{item.imgUrl}} -->
              </td>
              <td class="col-4 text-left">
                {{ item.itemName }}
              </td>
              <td class="col-2 text-left">
                {{ item.fromMinSellValue.toLocaleString('en', {useGrouping:true}) }} gp <br />
                {{ Math.floor(item.fromTcItemValue * 100) / 100 }} tc
              </td>
              <td class="col-2 text-left">
                {{ item.toMinSellValue.toLocaleString('en', {useGrouping:true}) }} gp <br />
                {{ Math.floor(item.toTcItemValue * 100) / 100 }} tc
              </td>
              <td  class="col-2 text-left pb-2">
                {{ item.profitGp.toLocaleString('en', {useGrouping:true}) }} gp
                <br />
                {{ item.profitTc }}
                tc
              </td>
 
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import images from "@/assets/images";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      images: images,
      search: "",
    };
  },
  computed: {
    ...mapState(["transferItems", "worldsData"]),
    headers() {
      return [
        { text: "", value: "", class: "warning--text" },
        { text: "World", value: "world", class: "warning--text" },
        {
          text: "From",
          value: "fromMinSellValue",
          class: "warning--text",
        },
        { text: "To", value: "toMinSellValue", class: "warning--text" },
        { text: "Diference", value: "profitTc", class: "warning--text" },
      ];
    },
  },
  methods: {
    ...mapMutations(["getHistory"]),
    test(name) {
      console.log(name);
    },
    customRowClass() {
      return "background";
    },
    filterOnlyCapsText(value, search, item) {
      item;
      const upperCasedSearch = search.toUpperCase();
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLocaleUpperCase().indexOf(upperCasedSearch) !== -1
      );
    },
  },
};
</script>

<style scoped>
.myrow:hover {
  background-color: rgba(12, 25, 32, 0.25) !important;
}
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147) !important;
}

.default-text {
  font-family: initial !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: rgb(238, 195, 147) !important;
}

.border {
  border-radius: 10px;
}
</style>